/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetRiskPolicyRequest,
  GetRiskPolicySecurity,
} from "../models/operations/getriskpolicy.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildRiskPoliciesGetQuery,
  prefetchRiskPoliciesGet,
  queryKeyRiskPoliciesGet,
  RiskPoliciesGetQueryData,
} from "./riskPoliciesGet.core.js";
export {
  buildRiskPoliciesGetQuery,
  prefetchRiskPoliciesGet,
  queryKeyRiskPoliciesGet,
  type RiskPoliciesGetQueryData,
};

export type RiskPoliciesGetQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getRiskPolicy risk
 *
 * @remarks
 * Get a risk analysis policy by ID.
 */
export function useRiskPoliciesGet(
  request: GetRiskPolicyRequest,
  security?: GetRiskPolicySecurity | undefined,
  options?: QueryHookOptions<
    RiskPoliciesGetQueryData,
    RiskPoliciesGetQueryError
  >,
): UseQueryResult<RiskPoliciesGetQueryData, RiskPoliciesGetQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildRiskPoliciesGetQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getRiskPolicy risk
 *
 * @remarks
 * Get a risk analysis policy by ID.
 */
export function useRiskPoliciesGetSuspense(
  request: GetRiskPolicyRequest,
  security?: GetRiskPolicySecurity | undefined,
  options?: SuspenseQueryHookOptions<
    RiskPoliciesGetQueryData,
    RiskPoliciesGetQueryError
  >,
): UseSuspenseQueryResult<RiskPoliciesGetQueryData, RiskPoliciesGetQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildRiskPoliciesGetQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setRiskPoliciesGetData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      id: string;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: RiskPoliciesGetQueryData,
): RiskPoliciesGetQueryData | undefined {
  const key = queryKeyRiskPoliciesGet(...queryKeyBase);

  return client.setQueryData<RiskPoliciesGetQueryData>(key, data);
}

export function invalidateRiskPoliciesGet(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      id: string;
      gramKey?: string | undefined;
      gramSession?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "policies", "get", ...queryKeyBase],
  });
}

export function invalidateAllRiskPoliciesGet(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "policies", "get"],
  });
}
